/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { Breadcrumb } from "components/atoms/Breadcrumb";
import { TermSidebar } from "features/terms/TermSidebar";
import React from "react";
import { SubContentsLayout } from "ui/SubContentsLayout";

export const TermsOfService: React.FC = () => {
  const classes = styles();

  return (
    <SubContentsLayout>
      <Breadcrumb
        // @ts-expect-error TS2322
        paths={[
          // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
          ["/", "ホーム"],
          // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
          [null, "利用規約"],
        ]}
      />

      <div css={classes.root}>
        {/* サイドバーを表示する */}
        <TermSidebar />

        {/* コンテンツを表示する */}
        <div css={classes.main}>
          <TermsOfServiceIframe />
        </div>
      </div>
    </SubContentsLayout>
  );
};

export const TermsOfServiceIframe: React.FC = () => {
  return (
    <iframe
      // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
      title="利用規約"
      src="https://docs.google.com/document/d/e/2PACX-1vTJ99oSN8lAvp7mTfhSJyGLuQ0nkZ5KKuUazseTp9GNfgLQwe0_b0qQ_Trz_obZhe5BNJOOD4kPcoje/pub?embedded=true"
    ></iframe>
  );
};

const styles = () => {
  return {
    root: css`
      display: grid;
      grid-template-columns: 100%;
      grid-gap: 16px;
      width: 90%;
      max-width: 1140px;
      padding: 80px 0;
      margin: 0 auto;
      @media screen and (min-width: 768px) {
        grid-template-columns: 320px auto;
      }
    `,
    main: css`
      position: relative;
      width: 100%;
      iframe {
        width: 100%;
        height: 5400px;
      }
    `,
  };
};
